import { useMutation } from '@tanstack/vue-query'

import { queryKeys } from './useQueryReferredWorkspaces'
import { useFetchReferredWorkspaces } from './useFetchReferredWorkspaces'

const remove = () => {
  const { remove: mutationFn } = useFetchReferredWorkspaces()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn,
    onMutate: (variables) => {
      queryClient.cancelQueries({
        queryKey: queryKeys.all(variables).queryKey,
      })
    },
    onSettled: (_, _1, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.all(variables).queryKey,
      })
    },
  })
}

export const useMutationReferredWorkspaces = {
  remove,
}
